export const NETWORK = process.env.GATSBY_NETWORK || 'test'
export const HORIZON_URL = NETWORK === 'public' ? "https://horizon.stellar.org" : "https://horizon-testnet.stellar.org"
export const TOKENS = {
    ENERGY: {
        CODE: process.env.GATSBY_ENERGY_TOKEN_CODE || "SLEEPCOIN",
        ISSUER: process.env.GATSBY_ENERGY_TOKEN_PUBKEY || "GCPI2HDDJGUEH6GKDPITM62PY2LYMNKCK26R3YJSMC7MVEQKVNU2EXFC",
    },
    MONEY: {
        CODE: process.env.GATSBY_MONEY_TOKEN_CODE || "MIGAS",
        ISSUER: process.env.GATSBY_MONEY_TOKEN_PUBKEY || "GDI4O3VQDX4U6CTFQ4LUTGTGS25CFCVQE7LXRFXQU4R3QXDH3ZUBJCT2",
    },
    BERRY: {
        CODE: process.env.GATSBY_BERRY_TOKEN_CODE || "BERRYTM",
        ISSUER: process.env.GATSBY_BERRY_TOKEN_PUBKEY || "GADSPWIL4TLTFNDO2YTYZOIABPFSFUD3YTCTWR4OXI5NB2QUQF3DTV3B",
    },
    MEAT: {
        CODE: process.env.GATSBY_MEAT_TOKEN_CODE || "MEATTM",
        ISSUER: process.env.GATSBY_MEAT_TOKEN_PUBKEY || "GCJXI4SRVC2S2O57TEZXM56Y5MPPAC4IEMNQ5Q4OGMYNVPFMY3KAXZ66",
    },
    FOOD: {
        CODE: process.env.GATSBY_FOOD_TOKEN_CODE || "FOODTM",
        ISSUER: process.env.GATSBY_FOOD_TOKEN_PUBKEY || "GC73KTOUBDSTJ7CAU24IOSKUKWERPEGF7HJHLIE426UMIXWDBIDCJEHS",
    },
    WOOD: {
        CODE: process.env.GATSBY_WOOD_TOKEN_CODE || "WOODTM",
        ISSUER: process.env.GATSBY_WOOD_TOKEN_PUBKEY || "GB7HLOGGOS25C4G4YSK2HQCMVFBZLQJAAXCADLVQEM7K3P62N6INC6JD",
    },
    IRON: {
        CODE: process.env.GATSBY_IRON_TOKEN_CODE || "IRONTM",
        ISSUER: process.env.GATSBY_IRON_TOKEN_PUBKEY || "GDFKSR65GXHS5EJWK3ZZCQDUOLTIVH75ZPLUEQGWP5WR7UAYPL6RQ6I3",
    },
    COAL: {
        CODE: process.env.GATSBY_COAL_TOKEN_CODE || "COALTM",
        ISSUER: process.env.GATSBY_COAL_TOKEN_PUBKEY || "GAN6KPKNJL6GPBTHLVNZO6Q3MFKWT376SLSH3V7Z3CCKGC63L4UKVMXM",
    },
    STEEL: {
        CODE: process.env.GATSBY_STEEL_TOKEN_CODE || "STEELTM",
        ISSUER: process.env.GATSBY_STEEL_TOKEN_PUBKEY || "GAQ6ERLYIMTUENSDD4NIRAFJOLLFN7DXEKDCMB7OYVSIVDFKUWJXDY7W",
    },
    STONE: {
        CODE: process.env.GATSBY_STONE_TOKEN_CODE || "STONETM",
        ISSUER: process.env.GATSBY_STONE_TOKEN_PUBKEY || "GDWGEDL5UL767MKGBLHDYMQQDWB5LSER2UKK2TT4LCEAPPLZFJOUF7WM",
    },
    AXE: {
        CODE: process.env.GATSBY_AXE_TOKEN_CODE || "AXETM",
        ISSUER: process.env.GATSBY_AXE_TOKEN_PUBKEY || "GDTONE3QKKJXBSELFQPJKTZP55BGGFCN2LGDCEEUPTAQUBHRFKN7RDAI",
    },
    PICKAXE: {
        CODE: process.env.GATSBY_PICKAXE_TOKEN_CODE || "PICKAXETM",
        ISSUER: process.env.GATSBY_PICKAXE_TOKEN_PUBKEY || "GCQEEKDNUK5UJZJNH5DO44P6HRWZGL2PHLG7TPDNXQADPRNCV2XAZ5VU",
    },
    HAMMER: {
        CODE: process.env.GATSBY_HAMMER_TOKEN_CODE || "HAMMERTM",
        ISSUER: process.env.GATSBY_HAMMER_TOKEN_PUBKEY || "GCZJOVE5NU5HDRTDJ5UDN64LGPLTAR6HFML4EK2TY7S372VPMDIC725B",
    },
    SPEAR: {
        CODE: process.env.GATSBY_SPEAR_TOKEN_CODE || "SPEARTM",
        ISSUER: process.env.GATSBY_SPEAR_TOKEN_PUBKEY || "GCZB3DW4TW4RBOQS5DWRPDWBZIGHL43CAHQU5MWZZW2LQXCP3PUAK6WL",
    },
}

